import React from 'react';
import styles from './table-v2.module.scss';
import { TiminatorTableColumn } from './types';

interface TableCellProps<Entity> {
    column: TiminatorTableColumn<Entity>;
    item: Entity;
    value: React.ReactNode;
}

export default function TableCell<Entity>({ column, item, value }: TableCellProps<Entity>) {
    const alignment = column.align ?? 'left';
    const verticalAlignment = column.verticalAlign ?? 'center';

    return (
        <div
            className={styles.tableCell}
            style={{
                textAlign: alignment,
                justifyContent: alignment === 'right'
                    ? 'flex-end'
                    : alignment === 'center'
                        ? 'center'
                        : 'flex-start',
                alignSelf: verticalAlignment === 'start'
                    ? 'start'
                    : verticalAlignment === 'end'
                        ? 'end'
                        : 'center',
                alignItems: verticalAlignment === 'start'
                    ? 'flex-start'
                    : verticalAlignment === 'end'
                        ? 'flex-end'
                        : 'center',
            }}>
            {column.format ? column.format(item) : value}
        </div>
    );
}
